import { apiClient } from '@shared/utils/api-client';
import type { PromoCode, CreatePromoCodeDto, UpdatePromoCodeDto } from '../types';

export const promoCodesApi = {
  getAll: async (): Promise<PromoCode[]> => {
    return apiClient.get<PromoCode[]>('/promo-codes');
  },

  create: async (data: CreatePromoCodeDto): Promise<PromoCode> => {
    return apiClient.post<PromoCode>('/promo-codes', data);
  },

  update: async (id: number, data: UpdatePromoCodeDto): Promise<PromoCode> => {
    return apiClient.patch<PromoCode>(`/promo-codes/${id}`, data);
  },

  delete: async (id: number): Promise<void> => {
    return apiClient.delete(`/promo-codes/${id}`);
  },
};
